import Activity from "view3/Activity.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    alert: state.alert,
    // city: state.city,
    user: state.user
  };
}

const ActivityContainer = connectFunction(mapStateToProps)(Activity);
export default ActivityContainer;
